// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"328":"8427275f","628":"52284d41","637":"c360dbed","656":"0cf4d17a","763":"6ab09af3","775":"f80f264c","805":"c360dbed","947":"61b87ed7","975":"8ce953b0"}[chunkId] + ".chunk.css";
};